import React from 'react';
import SolutionPublishEstimateSuccessContainer from 'containers/SolutionPublishEstimateSuccessContainer/SolutionPublishEstimateSuccessContainer';

export default function SolutionPublishEstimateSuccessPage() {
    return (
        <SolutionPublishEstimateSuccessContainer />
    )
}
